import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';

import { FamilyPerformanceCommentaryComponent } from './family-performance-commentary.component';
import { PerformanceCommentaryTextComponent } from './performance-commentary-text/performance-commentary-text.component';

@NgModule({
	declarations: [FamilyPerformanceCommentaryComponent, PerformanceCommentaryTextComponent],
	imports: [
		CommonModule,
		DataServiceModule,
		DisclosureModule,
		CwpNgFrameworkModule,
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyPerformanceCommentaryComponent }
		])
	]
})
export class FamilyPerformanceCommentaryModule { }
